import { useState } from "react";

import { useToast } from "@/components/ui/use-toast";

export const useImageUpload = (
  onImageSelected: (name: string, image: string) => void,
) => {
  const { toast } = useToast();
  const [image, setImage] = useState<string | null>(null);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const image = e.target?.result as string;
        setImage(image);
        onImageSelected(file.name, image);
      };
      reader.readAsDataURL(file);
    } else {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Please select a valid image file",
      });
    }
  };

  return {
    setImage,
    image,
    handleImageChange,
  };
};
